import { ChangeDetectionStrategy, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LoadingIndicatorComponent } from '../../shared/loading-indicator/loading-indicator.component';
import { ToastComponent } from '../../shared/toast/toast.component';

@Component({
  selector: 'product-healthcheck',
  standalone: true,
  imports: [LoadingIndicatorComponent, ToastComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './product-healthcheck.component.html',
  styleUrls: ['./product-healthcheck.component.scss', '../../base/base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductHealthcheckComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);

  // keep in alpha order by Name
  productHealthChecks: ProductHealthCheck[] = [
    { Name: 'API Stage', Link: `https://${environment.argoHostStage}/` },
    { Name: 'API Live Internal', Link: `https://${environment.argoHostLive}/` },
    {
      Name: 'Configurator',
      Link: `https://configurator.${environment.iconHostLive}/models/20468/`
    },
    {
      Name: 'ICON Elevation Visualizer',
      Link: `https://standalone.${environment.iconHostLive}/#/static-image-set/384c9582-15a5-4e7c-bd94-3d77650616c3`
    },
    {
      Name: 'KHov IFP',
      Link: `https://khovsecure.${environment.krakenHostLive}/#/floorplan/496413`
    },
    { Name: 'KHov ISM', Link: `https://khovsecure.${environment.krakenHostLive}/#/lotmap/100888` },
    {
      Name: 'Multi-Family ISM',
      Link: `https://multifamily.${environment.iconHostLive}/nochrome/159313/building/50`
    },
    { Name: 'MyScp Stage', Link: `https://app.${environment.iconHostStage}/scp/42254/home` },
    { Name: 'MyScp Live', Link: `https://app.${environment.iconHostLive}/scp/42254/home` },
    { Name: 'PDM', Link: `https://data.medialabstage.com/Account/Logon` }, // go to Account/Logon so no redirects
    { Name: 'RIFP Stage', Link: `https://rifp.${environment.iconHostStage}/#/floorplan/395579` },
    { Name: 'RIFP Live', Link: `https://rifp.${environment.iconHostLive}/#/floorplan/395579` },
    { Name: 'Pano Viewer Stage', Link: `https://panoviewer.${environment.iconHostStage}/pano/20` },
    { Name: 'Pano Viewer Live', Link: `https://panoviewer.${environment.iconHostLive}/pano/20` }
  ];

  async ngOnInit(): Promise<void> {
    // we need a proxy to get around CORS issues and not see false negatives
    // use Azure hosted Argo since most unlikely to be down
    const cloudArgo = environment.argoHostLive.replace('api', 'argo');
    const apiProxy = `https://${cloudArgo}/api/utility/pass-thru?url=`;

    const promises = this.productHealthChecks.map(async hc => {
      try {
        const response = await fetch(apiProxy + hc.Link, {
          headers: { 'Cache-Control': 'no-cache' }
        });
        hc.IsHealthy = response?.ok ?? false;
      } catch (error) {
        console.error(error);
        hc.IsHealthy = false;
      } finally {
        hc.HasChecked = true;
        this.cdr.markForCheck();
      }
    });

    await Promise.all(promises);
  }
}

class ProductHealthCheck {
  Name: string;
  Link: string;
  IsHealthy?: boolean;
  HasChecked?: boolean;
}
